// URL helpers for language-scoped routes
export function langPath(lang, path = "") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  if (clean === "/") return `/${lang}`;
  return `/${lang}${clean}`;
}

export function switchLangPath(currentPathname, targetLang) {
  // Replace leading /ar or /en with target lang
  if (/^\/(ar|en)(\/|$)/.test(currentPathname)) {
    return currentPathname.replace(/^\/(ar|en)/, `/${targetLang}`);
  }
  return `/${targetLang}`;
}

// Normalize a pathname by stripping trailing slash (except for root)
export function normalizePath(p) {
  if (!p) return "/";
  if (p.length > 1 && p.endsWith("/")) return p.slice(0, -1);
  return p;
}

// Given a language-prefixed href like "/ar/#contact", return { path, hash }
// where path is the pure pathname without trailing slash.
export function splitHrefHash(href) {
  const [rawPath, hash] = href.split("#");
  return { path: normalizePath(rawPath || "/"), hash: hash || "" };
}
